<template>
  <v-content>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="titulos">Tipos de Recursos</h1>
          <div class="text-xs-left">
            <v-btn fab dark small color="teal" @click="openDialogCreate()">
              <v-icon dark>add</v-icon>
            </v-btn>
          </div>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            :pagination.sync="pagination"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td class="justify-center px-0">
                <v-btn icon class="mx-0" @click="openDialogModify(props.item)">
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="openConfirmDialog(props.item.id)">
                  <v-icon color="error">delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
          </div>
          <v-snackbar
            :timeout= 6000
            :color="color"
            :multi-line="'multi-line'"
            v-model="snackbar">
            <v-icon dark>error_outline</v-icon>
            {{ error }}
            <v-btn dark flat @click.native="snackbar = false">Cerrar</v-btn>
          </v-snackbar>
        </v-flex>
        <ts-dialog :dialog="dialog" :options="options" @close="dialog=false" @clicked="accion"></ts-dialog>
        <confirm ref="confirm"></confirm>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable */
  import '@/assets/css/custom.css'
  import Shared from '@/services/Shared';
  import Confirm from '@/components/dialogs/Confirm.vue'
  import TsDialog from '@/components/dialogs/DialogType.vue'
  export default {
    data() {
      return {
        items: [],
        headers: [
          { text: 'Nombre', value: 'name' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
        ],
        pagination: {
          rowsPerPage: 10
        },
        dialog: false,
        options: {},
        error: null,
        snackbar: false,
        color: '',
      }
    },
    created() {
      this.types()
    },
    methods: {
      async types() {
        try {
          const response = await Shared.resourcesTypes()
          this.items = response.data.data
        } catch (err) {
          console.log(err)
        }
      },
      navigateTo (route) {
        this.$router.push(route)
      },
      openConfirmDialog(id){
        this.$refs.confirm.open('Eliminar', '¿Desea eliminar el recurso?', { color: 'error' }).then((confirm) => {
          if(confirm){
            this.deleteType(id)
          }
        });
      },
      openDialogModify(item){
        this.options = {
          title: 'Modificar tipo',
          btnName: 'Modificar',
          modificar: true,
          item
        }
        this.dialog = true
      },
      openDialogCreate(){
        this.options = {
          title: 'Crear tipo',
          btnName: 'Crear',
          modificar: false
        }
        this.dialog = true
      },
      accion (items){
        if(items.modificar){
          this.modificarTipo(items)
        }else{
          this.crearTipo(items)
        }
      },
      async modificarTipo(items){
        try {
          const response = await Shared.modifyType({
            id: items.id,
            name: items.name,
          })
          this.error = response.data.msg
          this.snackbar = true
          this.color = 'success'
          this.types()
        } catch (err) {
          this.error = err.response.data.msg
          this.snackbar = true
          this.color = 'error'
        }
      },
      async crearTipo(items){
        try {
          const response = await Shared.createType({
            name: items.name,
          })
          this.error = response.data.msg
          this.snackbar = true
          this.color = 'success'
          this.types()
        } catch (err) {
          this.error = err.response.data.msg
          this.snackbar = true
          this.color = 'error'
        }
      },
      async deleteType(id){
        try{
          const response = await Shared.deleteType({
            id: id
          })
          this.error = response.data.msg
          this.snackbar = true
          this.color = 'success'
          this.types()
        }catch(err){
          this.error = err.response.data.msg
          this.snackbar = true
          this.color = 'error'
        }
      },
    },
    computed: {
      pages () {
        if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) return 0

        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      }
    },
    components: {
      Confirm,
      TsDialog
    }
  };
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/ResourcesTypes.vue